import { SelectOption } from '../classes'
import { MessageTemplate } from '../model/message-template'
import { titlecase } from '../utils/titlecase'

export const MessageTemplateTypes: SelectOption<MessageTemplate.TYPE>[] = Object.values(MessageTemplate.TYPE).map(value => ({
  value,
  viewValue: titlecase(value.replace(/\./g, ' ')),
}))
